import React, { Component } from 'react';

import { CountryContext } from 'context/CountryContext';

export const withCountryContext = (WrappedComponent) => {
  return class extends Component {
    render() {
      return (
        <CountryContext.Consumer>
          {(context) => (
            <WrappedComponent contextCountry={context} {...this.props} />
          )}
        </CountryContext.Consumer>
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/withCountryContext/withCountryContext.js